import { MoveOrderEntryToNewIndex } from "./dndElementHelper"

export function dndQOMoveQuestionToGroup(
  questionOrders,
  questionOrderId,
  questionGroupId,
  overQuestionId
) {
  let updatedQuestionOrders = JSON.parse(JSON.stringify(questionOrders))

  //Find indexes of objects
  const questionOrderIndex = updatedQuestionOrders.findIndex(
    (order) => order.id === questionOrderId
  )
  const questionGroupOrderIndex = updatedQuestionOrders.findIndex(
    (order) => order.questionGroup?.id === questionGroupId
  )

  //find objects
  let questionOrder = updatedQuestionOrders[questionOrderIndex]
  let question = questionOrder?.question
  let questionGroupOrder = updatedQuestionOrders[questionGroupOrderIndex]
  let questionGroup = questionGroupOrder.questionGroup
  let questionGroupQuestion = questionGroup.questions.find(
    (existingQuestions) => existingQuestions.id === question?.id
  )

  //Mark QuestionOrder as deleted
  if (!questionOrder.isDeleted) {
    updatedQuestionOrders[questionOrderIndex] = {
      ...questionOrder,
      isDeleted: true,
      removeQuestion: true, //Indicate that the question should be removed from this order entry
    }
  }

  if (!questionGroupQuestion) {
    //Add question to group
    question.groupOrder = questionGroup.questions.length + 1
    questionGroup.questions = [...questionGroup.questions, question]

    updatedQuestionOrders[questionGroupOrderIndex].questionGroup = questionGroup
  } else {
    questionGroupQuestion.isActive = true
  }

  //If we are dragging over an existing question in the group, move the new question to that index
  if (overQuestionId && overQuestionId !== question.id) {
    updatedQuestionOrders[questionGroupOrderIndex].questionGroup.questions =
      MoveOrderEntryToNewIndex(
        updatedQuestionOrders[questionGroupOrderIndex].questionGroup.questions,
        question.id,
        overQuestionId
      )
  }

  //return results
  return {
    questionOrders: updatedQuestionOrders,
    questionGroupOrderId: questionGroupOrder?.id,
  }
}

export function dndQOMoveQuestionOutOfGroup(
  questionOrders,
  questionOrderId,
  questionGroupOrderId
) {
  let updatedQuestionOrders = JSON.parse(JSON.stringify(questionOrders))

  //Find indexes of objects
  const questionOrderIndex = updatedQuestionOrders.findIndex(
    (order) => order.id === questionOrderId
  )
  const questionGroupOrderIndex = updatedQuestionOrders.findIndex(
    (order) => order.id === questionGroupOrderId
  )

  //find objects
  let questionOrder = updatedQuestionOrders[questionOrderIndex]
  let question = questionOrder?.question
  let questionGroupOrder = updatedQuestionOrders[questionGroupOrderIndex]
  let questionGroup = questionGroupOrder.questionGroup
  let questionGroupQuestion = questionGroup.questions.find(
    (existingQuestions) => existingQuestions.id === question?.id
  )

  //Restore QuestionOrder to active
  if (questionOrder.isDeleted) {
    updatedQuestionOrders[questionOrderIndex] = {
      ...questionOrder,
      isDeleted: false,
      removeQuestion: false, //indicate that the question should not be removed from the order
    }
  }

  //Remove
  if (questionGroupQuestion && !questionGroupQuestion?.isDeleted) {
    questionGroupQuestion.isActive = false
  }

  return updatedQuestionOrders
}
